import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import AppHoc from "../../../../../../generics/AppHOC";
import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import css from "../../common/anomalyMagneticStyle.less";
import Heatmapview from "./HeatmapView";
import * as actions from "../../actions";
import { connect } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import PredictiveNetworksTabs from "../../../../PredictiveNetworksTabs";
import { getSiteAttr } from "../../../../../../config/reqConfig/anomalyDetection";
import ApiService from "../../../../../../config/api-config";
import useI18n from "../../../../../../i18n/useI18n";
import { routeURLs } from "../../../../../../utils/enums";

const mapStateToProps = (state) => {
  return {
    adKey: state.vanalytics.adKey,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

const [HbrCard] = reactWrapper(["hbr-card"]);

const SingleSite = (props) => {
  const { tViews } = useI18n("views");
  const navigate = useNavigate();
  const [locationAttr, setLocationAttr] = useState(null);
  const [locationHour, setLocationHour] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0, "smooth");
  }, []);

  useEffect(() => {
    const runEffect = async () => {
      if (props.globalFilter.selectedSite === -1) {
        navigate(routeURLs.ad);
        return;
      }
      let LocationAttributes = JSON.parse(
        localStorage.getItem("local_details"),
      );
      if (
        locationHour &&
        ((LocationAttributes &&
          props.globalFilter.selectedSite !== LocationAttributes?.local_site) ||
          (!LocationAttributes && props.globalFilter.selectedSite !== -1))
      ) {
        const payload = getSiteAttr(
          locationHour,
          props.globalFilter.selectedSite,
        );
        const res = await ApiService.getSiteAttributes(payload);
        if (!res.errorObject) {
          let local_details = JSON.stringify({
            local_site: res.data?.data[0]?.site_name,
            local_location: res.data?.data[0]?.city,
          });
          localStorage.setItem("local_details", local_details);
          setLocationAttr(JSON.parse(local_details));
        }
      } else if (LocationAttributes) {
        setLocationAttr(LocationAttributes);
      } else {
        setLocationAttr(null);
      }
    };

    runEffect();
  }, [
    props.globalFilter.selectedSite,
    props.globalFilter.selectedNhName,
    locationHour,
  ]);

  const getLocalLocation = useCallback((hour) => {
    setLocationHour(hour);
  }, []);

  return (
    <div>
      <HbrCard
        className={css["ad-ss-heatmap-widget"]}
        container={true}
        role="region"
        aria-label={tViews("a11yLabels.singleSiteHeatmapWidget")}
      >
        <PredictiveNetworksTabs />
        {
          <div
            className={css["ss-attr-details"]}
            role="group"
            aria-label={tViews("a11yLabels.siteDetails")}
          >
            <div>
              <div className="hbr-css__text-primary-xs-semibold" role="text">
                {tViews("predictiveNetworks.localSite")}
              </div>
              <div
                className="hbr-css__text-primary-xs"
                id="va_ad_site_name"
                tabIndex="0"
              >
                {locationAttr?.local_site}
              </div>
            </div>
            <div>
              <div className="hbr-css__text-primary-xs-semibold" role="text">
                {tViews("predictiveNetworks.localLocation")}
              </div>
              <div
                className="hbr-css__text-primary-xs"
                id="va_ad_local_location"
                tabIndex="0"
              >
                {locationAttr?.local_location}
              </div>
            </div>
          </div>
        }
        <Heatmapview
          selectedSite={props.globalFilter.selectedSite}
          adKey={props.adKey}
          actions={props.actions}
          getLocalLocation={getLocalLocation}
        />
      </HbrCard>
    </div>
  );
};

SingleSite.propTypes = {
  globalFilter: PropTypes.object,
  setSelectedSite: PropTypes.func,
  adKey: PropTypes.object,
  actions: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppHoc(SingleSite));
